import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface FieldProps {
  label: ReactNode;
  hint?: ReactNode;
  /** Validatsiya xatosi — maydon OSTIDA, izohning o'rnida. */
  error?: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * Yorliq + nazorat, `<label>` ning ICHIDA.
 *
 * `htmlFor`/`id` juftligi emas — juftlik bir xil formani ikki marta chizganda (masalan har
 * qatorda takrorlanadigan filtr) takroriy `id` ga olib keladi, va o'sha paytda yorliq mutlaqo
 * boshqa maydonni ko'rsatib turadi. O'rab olingan yorliqda bunday xato bo'lishi mumkin emas.
 *
 * Izoh esa yorliqdan TASHQARIDA: `<label>` ichidagi har qanday matn maydonning nomiga qo'shilib
 * ketadi, ya'ni "Bilet raqamlari" degan maydon ekran o'quvchisiga butun boshli izoh bilan birga
 * o'qilardi.
 *
 * Xato izohning O'RNIGA chiziladi, uning ostiga emas: ikkalasi birga turganda maydon ostidagi
 * matn ikki qatorga cho'ziladi va filtrlar qatori sakrab ketadi. Xato paytida muhimi — nima
 * noto'g'ri ekani, maydon nima uchun kerakligi emas.
 */
export function Field({ label, hint, error, children, className }: FieldProps) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-1.5', className)}>
      <label className="flex min-w-0 flex-col gap-1.5">
        <span className="text-sm leading-none font-medium">{label}</span>
        {children}
      </label>
      {error ? (
        <span role="alert" className="text-destructive text-xs">
          {error}
        </span>
      ) : hint ? (
        <span className="text-muted-foreground text-xs">{hint}</span>
      ) : null}
    </div>
  );
}
